import React from "react";

const initState = [undefined, () => {}];

const MapContext = React.createContext(initState);

export default MapContext;
